import * as React from "react";
import { SVGProps } from "react";

const SvgTwoHearts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 248 347"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M238 .8H10.4S.8 1.1.8 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h227.7s9.5-.3 9.5-12.9V13.7C247.5 1.1 238 .8 238 .8Z"
      fill="#fff"
    />
    <mask
      id="two-hearts_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={187}
      width={248}
      height={160}
    >
      <path
        d="M146.3 187.2H.8v146.1c0 12.6 9.6 12.9 9.6 12.9H238s9.5-.3 9.5-12.9V187.2H146.3Z"
        fill="url(#two-hearts_svg__a)"
      />
    </mask>
    <g mask="url(#two-hearts_svg__b)">
      <path
        d="M146.3 187.2H.8v146.1c0 12.6 9.6 12.9 9.6 12.9H238s9.5-.3 9.5-12.9V187.2H146.3Z"
        fill="url(#two-hearts_svg__c)"
      />
    </g>
    <mask
      id="two-hearts_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={248}
      height={174}
    >
      <path
        d="M.8 173.1H247.5V13.7C247.5 1.1 238 .8 238 .8H10.4S.8 1.1.8 13.7v159.4Z"
        fill="url(#two-hearts_svg__d)"
      />
    </mask>
    <g mask="url(#two-hearts_svg__e)">
      <path
        d="M.8 173.1H247.5V13.7C247.5 1.1 238 .8 238 .8H10.4S.8 1.1.8 13.7v159.4Z"
        fill="url(#two-hearts_svg__f)"
      />
    </g>
    <mask
      id="two-hearts_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={243}
      height={347}
    >
      <path
        d="M247 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9.6s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9H238s9.6-.3 9.6-12.9V13.7C247.6 1.1 238 .8 238 .8h-.5s9.5.3 9.5 12.9Z"
        fill="url(#two-hearts_svg__g)"
      />
    </mask>
    <g mask="url(#two-hearts_svg__h)">
      <path
        d="M247 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9.6s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9H238s9.6-.3 9.6-12.9V13.7C247.6 1.1 238 .8 238 .8h-.5s9.5.3 9.5 12.9Z"
        fill="url(#two-hearts_svg__i)"
      />
    </g>
    <mask
      id="two-hearts_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={243}
      height={347}
    >
      <path
        d="M1.3 333.4V14.2c0-12.6 9.6-12.9 9.6-12.9h227.8s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H10.4S.8 1.1.8 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h.5c0-.1-9.6-.3-9.6-12.9Z"
        fill="url(#two-hearts_svg__j)"
      />
    </mask>
    <g mask="url(#two-hearts_svg__k)">
      <path
        d="M1.3 333.4V14.2c0-12.6 9.6-12.9 9.6-12.9h227.8s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H10.4S.8 1.1.8 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h.5c0-.1-9.6-.3-9.6-12.9Z"
        fill="url(#two-hearts_svg__l)"
      />
      <mask
        id="two-hearts_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={2}
        height={299}
      >
        <path
          d="M.8 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.2-1.8-.3-3.6-.5-5.4Z"
          fill="url(#two-hearts_svg__m)"
        />
      </mask>
      <g mask="url(#two-hearts_svg__n)">
        <path
          d="M.8 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.2-1.8-.3-3.6-.5-5.4Z"
          fill="url(#two-hearts_svg__o)"
        />
      </g>
    </g>
    <path
      d="M26.4 67.5c-5.1 3.8-7.7 7.7-7.8 7.8-.1-.1-2.6-4.1-7.8-7.8-5.2-3.8-6.4-8.6-4.5-12.2 1.9-3.6 9.3-5.4 12.3 1.8 3-7.2 10.4-5.4 12.3-1.8 1.9 3.6.7 8.4-4.5 12.2ZM22 42.2c.7 0 1.3 0 1.7-.1.4-.1.8-.2 1-.4.3-.2.5-.5.6-.8.2-.3.3-.8.6-1.5h1.9l-.4 6.4h-18v-1c.6-1.5 1.5-3.1 2.5-4.7 1.1-1.6 2.6-3.5 4.5-5.7 1.7-1.9 2.9-3.3 3.6-4.2.8-1 1.4-2 1.8-2.7.4-.8.7-1.5.9-2.2.2-.7.3-1.4.3-2 0-1.1-.2-2.1-.5-2.9-.3-.8-.9-1.5-1.6-2-.7-.5-1.6-.7-2.7-.7-2.7 0-4.6 1.5-5.5 4.5h-2.6V18c1.8-.8 3.4-1.4 4.9-1.8 1.5-.4 2.9-.6 4.1-.6 2.7 0 4.7.6 6.1 1.8 1.4 1.2 2.1 2.9 2.1 5.2 0 .8-.1 1.5-.2 2.1-.2.6-.4 1.3-.7 1.9-.3.6-.8 1.3-1.3 2-.6.7-1.2 1.5-1.8 2.2-.7.7-1.8 2-3.5 3.7-2.8 2.9-4.8 5.5-6.1 7.7H22ZM219.4 279c5.1-3.8 7.7-7.7 7.8-7.8.1.1 2.6 4.1 7.8 7.8 5.2 3.8 6.4 8.6 4.5 12.2-1.9 3.6-9.3 5.4-12.3-1.8-3 7.2-10.4 5.4-12.3 1.8-1.9-3.6-.7-8.4 4.5-12.2ZM223.8 304.2c-.7 0-1.3 0-1.7.1-.4.1-.8.2-1 .4-.3.2-.5.5-.6.8-.2.3-.3.8-.6 1.5H218l.4-6.4h18v1c-.6 1.5-1.5 3.1-2.5 4.7-1.1 1.6-2.6 3.5-4.5 5.6-1.7 1.9-2.9 3.3-3.6 4.2-.8 1-1.4 2-1.8 2.7-.4.8-.7 1.5-.9 2.2-.2.7-.3 1.4-.3 2 0 1.1.2 2.1.5 2.9.3.8.9 1.5 1.6 2 .7.5 1.6.7 2.7.7 2.7 0 4.6-1.5 5.5-4.5h2.6v4.2c-1.8.8-3.4 1.4-4.9 1.8-1.5.4-2.9.6-4.1.6-2.7 0-4.7-.6-6.1-1.8-1.4-1.2-2.1-2.9-2.1-5.2 0-.8.1-1.5.2-2.1.2-.6.4-1.3.7-1.9.3-.6.8-1.3 1.3-2 .6-.7 1.2-1.5 1.8-2.2.7-.8 1.8-2 3.5-3.7 2.8-2.9 4.8-5.5 6.1-7.7h-8.3v.1ZM139.6 82.4c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.2 1.3 16.7-9 24.2ZM108.8 264c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.2-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.1-1.4-16.6 9-24.2Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="two-hearts_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(120.356 -116.964) scale(499.516)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(120.356 -116.964) scale(499.516)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(125.298 319.576) scale(357.935)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(125.298 319.576) scale(357.935)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.753 .645) scale(397.434)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.753 .645) scale(397.434)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(68.2 101.334) scale(338.506)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(68.2 101.334) scale(338.506)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 129.002 .322) scale(397.383)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-hearts_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 129.002 .322) scale(397.383)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgTwoHearts;
